import { render, staticRenderFns } from "./Ask.vue?vue&type=template&id=261d8a4c&scoped=true&"
import script from "./Ask.vue?vue&type=script&lang=js&"
export * from "./Ask.vue?vue&type=script&lang=js&"
import style0 from "./Ask.vue?vue&type=style&index=0&id=261d8a4c&lang=less&scoped=true&"
import style1 from "./Ask.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261d8a4c",
  null
  
)

export default component.exports